<div class="row">
  <div class="col-md-6">
    <table class="simple-form">
  
      <ng-container *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails)">
        <tr>
          <th><label for="title">Title</label></th>
          <td>
            <div class="form-group">
              <app-dropdown-input [disabled]="!updateBeneficiary" #titleSelect id="title" [options]="titleOptions"
                [parentForm]="paymentInfoForm" name="title" placeholder="Select title">
              </app-dropdown-input>
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="firstName">First Name</label></th>
          <td>
            <div class="form-group">
              <input type="text" id="firstName" class="form-control" formControlName="firstName">
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="lastName">Last Name</label></th>
          <td>
            <div class="form-group">
              <input type="text" id="lastName" class="form-control" formControlName="lastName">
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="beneficiaryId">Caxton Beneficiary ID</label></th>
          <td>
            <div class="form-group">
              <input type="text" id="beneficiaryId" class="form-control" formControlName="beneficiaryId">
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="country">Country</label></th>
          <td>
            <div class="form-group">
              <app-autosuggest-dropdown-input #countrySelect [options]="countries" [parentForm]="paymentInfoForm"
                controlName="country" placeholder="Select country..."></app-autosuggest-dropdown-input>
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="currency">Currency</label></th>
          <td>
            <div class="form-group">
              <div class="form-group">
                <app-autosuggest-dropdown-input #currencySelect [options]="currencies" [parentForm]="paymentInfoForm"
                  controlName="currency" placeholder="Select currency..."></app-autosuggest-dropdown-input>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
  
    </table>
  </div>
  
  <div class="col-md-6" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails)">
  
    <table class="simple-form">
      <tr *ngIf="bankRequirements.usesIban">
        <th><label for="iban">IBAN</label></th>
        <td>
          <div class="form-group">
            <input type="text" id="iban" class="form-control" formControlName="iban">
          </div>
        </td>
      </tr>
  
      <tr *ngIf="bankRequirements.usesSortCode">
        <th><label for="sortCode">Sort Code</label></th>
        <td>
          <div class="form-group">
            <input type="text" id="sortCode" class="form-control" formControlName="sortCode">
            <span class="mandatory-label">*Without dashes, eg. 123456</span>
          </div>
        </td>
      </tr>
  
      <tr *ngIf="bankRequirements.usesSortCode || bankRequirements.usesSwift">
        <th><label for="accountNumber">Account Number</label></th>
        <td>
          <div class="form-group">
            <input type="text" id="accountNumber" class="form-control" formControlName="accountNumber">
          </div>
        </td>
      </tr>
  
      <tr *ngIf="bankRequirements.usesSwift">
        <th><label for="swift">SWIFT</label></th>
        <td>
          <div class="form-group">
            <input type="text" id="swift" class="form-control" formControlName="swift">
          </div>
        </td>
      </tr>
  
      <tr>
        <th><label for="swift">Account Owner Address</label></th>
        <td>
          <div class="form-group">
            <textarea type="text" id="accountOwnerAddress" class="form-control"
              formControlName="accountOwnerAddress"></textarea>
            <span class="mandatory-label">*Mandatory for Canada</span>
          </div>
        </td>
      </tr>
    </table>
  
    <button class="btn btn-secondary" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)"
      [disabled]="updateBeneficiary" (click)="editBeneficiary()">Change Bank Details
    </button>
  </div>
  
  <div class="col-md-12" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails)">
    <button (click)="togglePreviousBeneficiaries()" class="btn btn-secondary">Previous Beneficiary IDs</button>
    <ul *ngIf="showPreviousBeneficiaries && previousBeneficiaryIds.length !== 0">
      <li *ngFor="let id of previousBeneficiaryIds">
        {{id}}
      </li>
    </ul>
    <p *ngIf="showPreviousBeneficiaries && previousBeneficiaryIds.length === 0">No previous beneficiary IDs.</p>
  </div>
  
  <div *ngIf="bankAccount.bankAccountEnabled" class="col-12 bank-account">
    <div class="row">
      <div class="col-12">
        <h2>Patient Bank Details</h2>
      </div>
  
      <div class="col-3">
        <p>
          <strong>Account Holder and Address</strong><br>
          <span [innerHtml]="bankAccount.bankNameAddress | replaceNewLines"></span>
        </p>
      </div>
      <div class="col-3">
        <p>
          <strong>Account Holder's Name</strong><br>
          {{ bankAccount.accountHolderName }}
        </p>
      </div>
      <div class="col-2">
        <p>
          <strong>Account Number</strong><br>
          {{ bankAccount.accountNumber }}
        </p>
      </div>
      <div class="col-2">
        <p>
          <strong>BIC/SWIFT Code</strong><br>
          {{ bankAccount.bicSwiftCode }}
        </p>
      </div>
      <div class="col-2">
        <p>
          <strong>Routing Number</strong><br>
          {{ bankAccount.routingNumber }}
        </p>
      </div>
    </div>
  
  </div>
</div>